// A/B Test Configuration for Flow Order
// Flow A (current): Property → Personal Info → Utilities → Checkout
// Flow B (new): Property → Utilities → Personal Info → Checkout

export type FlowType = 'A' | 'B';

// Zip codes for Flow B (all others default to Flow A)
export const FLOW_B_ZIP_CODES = new Set(['78258','75224']);

export function getFlowType(zipCode: string | undefined): FlowType {
  if (!zipCode) return 'A';
  return FLOW_B_ZIP_CODES.has(zipCode) ? 'B' : 'A';
}

// Step labels per flow
export const FLOW_STEP_LABELS: Record<FlowType, string[]> = {
  A: ['Property & Serviceability', 'Personal Info', 'Utilities', 'Set up'],
  B: ['Property & Serviceability', 'Utilities', 'Personal Info', 'Set up'],
};

// Route-to-step mapping per flow
export const FLOW_ROUTE_TO_STEP: Record<FlowType, Record<string, number>> = {
  A: {
    '/': 1,
    '/service-available': 1,
    '/property': 1,
    '/personal-info': 2,
    '/utilities': 3,
    '/plan-options': 3,
    '/checkout': 4,
    '/documents': 4,
    '/confirmation': 4,
  },
  B: {
    '/': 1,
    '/service-available': 1,
    '/property': 1,
    '/utilities': 2,
    '/plan-options': 2,
    '/personal-info': 3,
    '/checkout': 4,
    '/documents': 4,
    '/confirmation': 4,
  },
};
